// src/pages/NotAuthorized.jsx
import React from "react";

const NotAuthorized = () => {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>🚫 Not Authorized</h1>
      <p>You do not have permission to view this page.</p>
    </div>
  );
};

export default NotAuthorized;
